import { type JSX } from 'react';
import { gql } from '@apollo/client';
import { ProcessAktivitetIDType } from '../../Types/ProcessModel';
import { UserSignAndNameQuery } from '../../hoc/meHocs';
import { Query as QueryApollo } from '@apollo/client/react/components';

const tasksQuery = gql`
  query tasks {
    me {
      processtasks {
        ProcAktivitetID
        ProcAktivitet
        RUBRIK
        PAKT_ID
        DEADLINE
        DBNAME
        ANTAL
      }
    }
  }
`;

export interface ITask {
  ProcAktivitetID: ProcessAktivitetIDType;
  ProcAktivitet: string;
  RUBRIK: string;
  PAKT_ID: number;
  DEADLINE: string | null;
  DBNAME: string;
  ANTAL: number | null;
}

export interface IQueryProps {
  children: (loading: boolean, taks: ITask[]) => JSX.Element;
}

export const Query = (props: IQueryProps) => (
  <QueryApollo<any> query={tasksQuery}>
    {({ loading, data }) =>
      props.children(
        loading,
        data && data.me && data.me[0] && data.me[0].processtasks
          ? data.me[0].processtasks
          : []
      )
    }
  </QueryApollo>
);

const taTasks: ITask[] = [
  {
    ProcAktivitetID: 'paktLasaInFakturabuntAnkomstregistrera',
    ProcAktivitet: 'Ankomstregistrera fakturor',
    RUBRIK: 'Ankomstregistrering',
    PAKT_ID: 1,
    DEADLINE: '2018-11-20',
    DBNAME: 'Björkstena Pastorat',
    ANTAL: 22,
  },
  {
    ProcAktivitetID: 'paktSakgranskaMottagningsattesteraFaktura',
    ProcAktivitet: 'Definitivboka fakturor',
    RUBRIK: 'Definitivbokning',
    PAKT_ID: 2,
    DEADLINE: '2018-12-01',
    DBNAME: 'Björkstena Pastorat',
    ANTAL: 46,
  },
  {
    ProcAktivitetID: 'paktLasaInFakturabuntAnkomstregistrera',
    ProcAktivitet: 'Ankomstregistrera fakturor',
    RUBRIK: 'Ankomstregistrering',
    PAKT_ID: 1,
    DEADLINE: '2018-11-30',
    DBNAME: 'Almstena Församling',
    ANTAL: 17,
  },
  {
    ProcAktivitetID: 'paktSakgranskaMottagningsattesteraFaktura',
    ProcAktivitet: 'Definitivboka fakturor',
    RUBRIK: 'Definitivbokning',
    PAKT_ID: 2,
    DEADLINE: '2018-11-21',
    DBNAME: 'Nystad Pastorat',
    ANTAL: 6,
  },
  {
    ProcAktivitetID: 'paktKontrollattesteraFaktura',
    ProcAktivitet: 'Utred faktura',
    RUBRIK: 'Utredning',
    PAKT_ID: 5,
    DEADLINE: '2018-11-18',
    DBNAME: 'Almstena Församling',
    ANTAL: 3,
  },
  {
    ProcAktivitetID: 'paktSakgranskaMottagningsattesteraFaktura',
    ProcAktivitet: 'Definitivboka fakturor',
    RUBRIK: 'Definitivbokning',
    PAKT_ID: 2,
    DEADLINE: '2018-12-05',
    DBNAME: 'Almstena Församling',
    ANTAL: 8,
  },
  {
    ProcAktivitetID: 'paktLasaInFakturabuntAnkomstregistrera',
    ProcAktivitet: 'Ankomstregistrera fakturor',
    RUBRIK: 'Ankomstregistrering',
    PAKT_ID: 1,
    DEADLINE: '2018-11-27',
    DBNAME: 'Nystad Pastorat',
    ANTAL: 35,
  },
];

const crTasks: ITask[] = [
  {
    ProcAktivitetID: 'paktSakgranskaMottagningsattesteraFaktura',
    ProcAktivitet: 'Mottagningsattestera fakturor',
    RUBRIK: 'Mottagningsattestering',
    PAKT_ID: 1,
    DEADLINE: '2018-11-30',
    DBNAME: 'Almstena Församling',
    ANTAL: 3,
  },
  {
    ProcAktivitetID: 'paktBeslutsattesteraFaktura',
    ProcAktivitet: 'Beslutsattestera fakturor',
    RUBRIK: 'Definitivbokning',
    PAKT_ID: 2,
    DEADLINE: '2018-12-03',
    DBNAME: 'Almstena Församling',
    ANTAL: 2,
  },
  {
    ProcAktivitetID: 'paktKontrollattesteraFaktura',
    ProcAktivitet: 'Fyll i budgetunderlag - 2019 Årsbudget',
    RUBRIK: 'Budgetunderlag',
    PAKT_ID: 5,
    DEADLINE: '2018-11-01',
    DBNAME: 'Almstena Församling',
    ANTAL: 1,
  },
  {
    ProcAktivitetID: 'paktUpprattaManadsrapporterArsbokslut',
    ProcAktivitet: 'Kvittera månadsrapport - Okt 2018',
    RUBRIK: 'Månadsrapport',
    PAKT_ID: 7,
    DEADLINE: '2018-11-15',
    DBNAME: 'Almstena Församling',
    ANTAL: 1,
  },
];

/** Temporary tasks for presentation */
export const FakeTasksQuery = (props: IQueryProps) => (
  <UserSignAndNameQuery>
    {(loading, user) => {
      if (user == null) {
        return props.children(true, []);
      } else {
        let tasks;
        if (user.sign === 'TA') {
          tasks = taTasks;
        } else if (user.sign === 'CR') {
          tasks = crTasks;
        } else {
          return <Query>{props.children}</Query>;
        }
        return props.children(false, tasks);
      }
    }}
  </UserSignAndNameQuery>
);
